import React from 'react';
import { bool, element, node, object } from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import Autocomplete from '../Autocomplete';
import TagSelectLabel from './TagSelectLabel';

import defaultClasses from './TagSelect.module.css';

function itemToKey({ nodeId }) {
    return nodeId;
}

const TagSelect = ({
    control,
    disabled,
    error,
    helperText,
    kickerText,
    InputProps,
    label,
    LabelProps,
    multiple,
    required,
    ...props
}) => (
    <FormControl error={error} required={required}>
        <TagSelectLabel
            disabled={disabled}
            error={error}
            {...LabelProps}
        >
            {control} {label}
        </TagSelectLabel>
        <FormHelperText className={defaultClasses.kickerText}>
            {kickerText}
        </FormHelperText>
        <Autocomplete
            adornmentPosition="end"
            AdornmentProps={{
                classes: {
                    root: defaultClasses.adornment
                }
            }}
            disabled={disabled}
            hideSelected
            itemToKey={itemToKey}
            maxSuggestions={0}
            multiple={multiple}
            {...props}
            classes={{
                error: defaultClasses.autocompleteError,
                root:  defaultClasses.autocomplete
            }}
            error={error}
            InputProps={{
                classes: {
                    root: defaultClasses.autocompleteInput
                },
                disableUnderline: true,
                ...InputProps
            }}
        />
        <FormHelperText className={defaultClasses.helperText}>
            {helperText}
        </FormHelperText>
    </FormControl>
);

TagSelect.defaultProps = {
    disabled:   false,
    error:      false,
    InputProps: {},
    LabelProps: {
        classes: {}
    },
    multiple: true,
    required: false
};

TagSelect.propTypes = {
    control:    element,
    disabled:   bool,
    error:      bool,
    helperText: node,
    InputProps: object,
    kickerText: node,
    label:      node,
    LabelProps: object,
    multiple:   bool,
    required:   bool
};

export default TagSelect;
